class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.handleDelegatedClick = this.handleDelegatedClick.bind(this);// register the whole system to the element
   // this.handleButtonClick = this.handleButtonClick.bind(this);// register the whole system to the element
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  
  connectedCallback() {
    // event delegation to handle clicks on dynamically updated buttons
    this.addEventListener("click", this.handleDelegatedClick);
    this.addEventListener("click", this.handleButtonClick);
    console.log("Event delegation set up for CartDrawer.");
  }

  disconnectedCallback() {
    // Clean up the event listener to avoit unexpected firing
    this.removeEventListener("click", this.handleDelegatedClick);
    this.removeEventListener("click", this.handleButtonClick);
    console.log("Event delegation removed for CartDrawer.");
  }

  handleDelegatedClick(event) {
    const button = event.target.closest(".offer-box .product-form__submit");
    
    if (button) {
      event.preventDefault();
      console.log("Selling plan button clicked via delegation");
      addSellingPlane(button); // Call your logic
    }
  }
  
    // handleButtonClick(event) {
    //   const closeIcon = this.querySelector('.drawer__close')
    //   console.log("Selling plan button clicked",closeIcon);
    //   if(closeIcon){
    //     closeIcon.addEventListener('click',()=>{
    //       this.close()
    //     })
    //   }
      
    // }
  

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




//function to add selling plane to single plane
async function addSellingPlane(submitButton) {
  
  console.log("inside dom")
    if (submitButton) {
      console.log("inside dom")
      event.preventDefault(); 
      console.log('clicked on subscription btn')
      // Select the parent "offer-box" container via button
      const offerBox = submitButton.closest(".offer-box");
      const ids = submitButton.querySelector(".free-products");
      const freeProducts = JSON.parse(ids.value)
    console.log(freeProducts)

      if (!offerBox) {
        console.error("Offer box not found.");
        return;
      }

      // Collect form data from the offer-box
      const formData = new FormData();
      offerBox.querySelectorAll("input").forEach((input) => {
        if (input.name && input.value) {
          formData.append(input.name, input.value);
        }
      });

      //  the loading spinner
      const loadingSpinner = offerBox.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
      }

      try {
        // Step 1: Clear the cart
        // Step 2: Confirm the cart is empty
        // Step 3: Add the main product to the cart
        // Step 4: Add free products to the cart
        // Step 5: Fetch the updated cart data and update the UI
        // Step 6: Remove the spinner loader
        // After All Of Them Hide the loading spinner on error
        await fetch("/cart/clear.js", { method: "POST" });
        console.log("Cart cleared.");

        
        const cartResponseAfterClear = await fetch("/cart.js");
        const cartDataAfterClear = await cartResponseAfterClear.json();

        if (cartDataAfterClear.items.length > 0) {
          throw new Error("Failed to clear the cart.");
        }

        console.log("Cart is empty. Proceeding to add product.");

        
        const addProductResponse = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        if (!addProductResponse.ok) {
          throw new Error("Failed to add the main product to the cart.");
        }

        const productData = await addProductResponse.json();
        console.log("Main product added:", productData);

        
         addFreeProductsToCart(freeProducts);
        console.log("Free products added.");

        
        const updatedCartResponse = await fetch("/cart.js");
        const updatedCartData = await updatedCartResponse.json();
          updateCartSections() // just testing

        
        if (loadingSpinner) {
          loadingSpinner.classList.add("hidden");
        }

        console.log("Cart updated and spinner removed.");
      } catch (error) {
        console.error("Error adding product to cart:", error);

        
        if (loadingSpinner) {
          loadingSpinner.classList.add("hidden");
        }
      }
     
    }
}


document.querySelector('cart-drawer').addEventListener('click', (e) => {
  // Check if the target is ovaerlay div outside of cart in cart-drawer element
  if (e.target.matches('#CartDrawer-Overlay') || e.target.tagName === 'cart-drawer') {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      console.log('closing the cart')
      cartDrawer.classList.remove('active'); // Remove the active class
      document.body.classList.remove('overflow-hidden'); // Allow scrolling
    } else {
      console.error('cart-drawer element not found');
    }
  }else if ( e.target.closest('.drawer__close') ||e.target.tagName === 'cart-drawer'){
    console.log('closing the cart by button')
    const cartClose = document.querySelector('cart-drawer');
    if (cartClose) {
      console.log('closing the cart by button')
      cartClose.classList.remove('active'); // Remove the active class
      document.body.classList.remove('overflow-hidden'); // Allow scrolling
    } else {
      console.error('cart-drawer element not found');
    }
  }
});